export default {
  '0%': 1,
  '7%': 2,
  '19%': 3
};
